import React from 'react';
import autobind from 'autobind-decorator';
import { connect } from 'react-redux';

import services from 'core/services';
import { PureComponent, Page } from 'core/components';
import { Row, Col, Icon } from 'core/components/Framework7';
import { NodeTitleSwiper, ProductList, Filter, Availability } from 'content/components';
import { withLocale } from 'core/decorators';

import translations from './i18n';
import classes from './styles.module.css';
import SortableComponent from 'framework7/components/sortable/sortable';

class NodePage extends PureComponent {
  constructor(props) {
    super(props);

    this.router = this.$f7.views.current && this.$f7.views.current.router

    this.state = {
      productNodes: [],
      categoryNodes: null,
      current: null,
      parent: props.parent,
      filter: null,
      sort: props.sort,
      brands: [],
      availability: this.initialValue.checkAvailability,
      offset: 0,
      limit: 10,
      hasNext: true,
      loadingMore: false,
      initialLoad: true,
      key: null,
      params: null,
      empty: false,
    };

    this.props.translator.addModuleResource('node', translations);
  };

  get initialValue() {
    const { env } = this.props;

    return {
      checkAvailability: env ? env.checkAvailability : null,
    }
  }

  /**
   * @inheritdoc
   */
  componentDidMount() {
    const params = {
      store: 2
    }

    this.getNodeProduct();
    this.getNodeBrands(params)
  };

  /**
   * handle loading
   * @param {Boolian} loading 
   */
  loading(loading = false) {
    this.setState((prevState, props) => {
      return { loading: loading }
    });
  };

  loadingMore(loading = false) {
    this.setState((prevState, props) => {
      return { loadingMore: loading }
    });
  };

  loadMore() {
    this.loadingMore(true);
    this.getNodeProduct()
  }

  onScroll(params) {

  }

  getNodeBrands() {
    const { id } = this.props;

    const params = {
      store: 2
    }

    services.ecommerce.Node.getNodeBrands(id, params)
      .then(r => {
        this.setState({
          brands: r.data.brands
        })
      })
      .catch(e => {

      })
      .finally(r => {
        this.loading(false)
      })
  }

  changeSort(value, key = "order_by") {
    this.createRequest(this.state.filter, value, this.state.availability)
  }

  changeFilter(value, key = "brand") {
    this.createRequest(value, this.state.sort, this.state.availability)
  }

  changeAvailability(value) {
    this.createRequest(this.state.filter, this.state.sort, value)
  }

  createRequest(filter, sort, availability = true) {
    this.setState({
      offset: 0,
      limit: 10,
      hasNext: true,
      sort: sort,
      filter: filter,
      availability: availability,
      productNodes: [],
      initialLoad: true,
    }, () => {
      this.getNodeProduct()
    })
  }

  getNodeProduct() {
    const { id } = this.props;
    const { hasNext, limit, offset, availability, sort, filter } = this.state;

    if (!hasNext) {
      this.loading(false);
      this.loadingMore(false);
      this.setState({
        initialLoad: false
      })
      return
    }

    this.setState({
      empty: false,
    })

    this.loading(true);
    this.loadingMore(true);

    let searchParams = {
      store: 2,
      limit,
      offset,
      check_availability: availability,
    }

    if (sort) {
      searchParams.order_by = sort
    }

    if (filter) {
      searchParams.brand = filter
    }

    services.ecommerce.Node.getNodeProduct(id, searchParams)
      .then(r => {
        this.setState((prevState, props) => {
          const productNodes = this.state.productNodes.length > 0 ? [...this.state.productNodes, ...r.data.nodes] : r.data.nodes;

          return {
            productNodes: productNodes,
            limit: r.meta ? r.meta.limit : null,
            offset: r.meta ? r.meta.offset + r.meta.limit : null,
            hasNext: r.meta ? r.meta.next === "has next" ? (r.data && r.data.nodes && r.data.nodes.length > 0) : false : false,
            categoryNodes: r.data && r.data.categoryNodes && r.data.categoryNodes.length > 0 ? r.data.categoryNodes : (searchParams.offset > 0 ? prevState.categoryNodes : null),
            current: r.data ? r.data.current : null,
            parent: props.parent || (r.data ? r.data.parent : null),
          }
        })
      })
      .catch(e => {

      })
      .finally(r => {
        this.loading(false);
        this.loadingMore(false);
        this.setState({
          initialLoad: false
        })

        if (this.state.productNodes.length === 0) {
          this.setState({
            empty: true
          })
        }
      })
  }

  renderEmpty() {
    return (
      <Col width="100" className={`${classes.empty}`}>
        <Icon icon="mdi-basket" />
        <div className={'product-list-empty'}>{'مشتری گرامی'}<br />{'با تشکر از همراهی و صبوری شما، کالاهای این دسته به زودی معرفی می گردد.'}</div>
      </Col>
    )
  }

  render() {
    const { navigate } = this.props;
    const { productNodes, categoryNodes, current, parent, brands, hasNext, loadingMore, initialLoad, empty, sort, filter } = this.state;

    return (
      <Page
        pageName="node"
        title={current}
        showCart={true}
        showSearch={true}
        showBack={true}
        navigate={navigate}
      >
        <div className={classes.main}>
          <Filter
            filter={filter}
            sort={sort}
            brands={brands}
            onAvailabilityChange={this.changeAvailability}
            onSortChange={this.changeSort}
            onFilterChange={this.changeFilter}
          />

          {categoryNodes && categoryNodes.length > 0 &&
            <NodeTitleSwiper
              items={categoryNodes}
              highlight={false}
              // onNodeClicked={(nodeId) => navigate.navigate(`/node/${nodeId}`, { props: { navigate: navigate } })}
              onNodeClicked={nodeId => this.router && this.router.navigate(`/node/${nodeId}`)}
            />
          }

          {!empty ?
            <ProductList
              items={productNodes}
              hasNext={hasNext}
              loadMore={this.loadMore}
              loading={loadingMore}
              initialLoad={initialLoad}
              navigate={navigate}
              onScroll={this.onScroll}
              className={classes.infinite}
            /> : this.renderEmpty()}
        </div>
      </Page>
    );
  };
};

export default connect(
  state => ({
    cart: state.Cart.cart,
    env: state.General.env,
  }),
  {

  }
)(withLocale('node')(autobind(NodePage)));
